var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[_c('div',{ref:"map",staticClass:"map",attrs:{"role":"application","tabindex":"-1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }